import { refresh } from "@/lib/api/generated";

export const ORGANIZATION_CONTEXT_SETUP_ERROR_MESSAGE =
  "Organization was created but we couldn't finish setting it up. Please refresh the page or contact support.";

export class RefreshTokenMissingError extends Error {
  code = "REFRESH_TOKEN_MISSING" as const;

  constructor(
    message = "User session expired or no refresh token found. Please sign in again.",
  ) {
    super(message);
    this.name = "RefreshTokenMissingError";
  }
}

/**
 * Switches the user's WorkOS session into the given organization. Auth is
 * carried by the refresh cookie (HttpOnly), which the browser attaches to the
 * `/api/auth/refresh` request automatically. The backend issues new auth
 * cookies on the response; nothing is returned to JavaScript.
 */
export async function refreshOrganizationContext(
  workosOrgId: string,
): Promise<void> {
  await refresh({ organization_id: workosOrgId });
}
